<template>
  <section class="signup-section pt-5 pb-2">
    <div class="container">
      <div class="row g-0">
        <!-- First Column: Image with Text -->

        <div
          class="col-md-6 d-flex flex-column justify-content-center signup-image-column text-white /* Mobile styles (default) */ mt-3 mb-0 p-4 /* Override for md and larger */ mt-md-5 mb-md-3 p-md-5 /* Maybe add even different spacing for lg+ */ mt-lg-5 mb-lg-5"
        >
          <!-- Floating Badge -->
          <img
            src="/assets/badges/all.png"
            alt="Badge"
            class="floating-badge"
          />
          <h2 class="signup-header">REWARDS</h2>
          <span class="registerSubHeading"
            >Earn free gifts exploring Wicklow's beauty</span
          >
          <p class="signup-text">
            <span v-if="isRegistered">
              Hi <strong>{{ firstName }}</strong
              >, thanks for signing up! We have saved your details. If you would
              like to change them, fill in the form again and press register.<br />
              Note: Earned badges are tied to the email address
            </span>
            <span v-else>
              Register for our rewards scheme and earn badges and free gifts as
              you explore the beauty of Wicklow. Stay motivated on your journey.
              Just enter your name and email below to get started.
            </span>
          </p>
        </div>

        <!-- Second Column: Sign Up Form -->
        <div class="col-md-6 bg-white">
          <h2 class="signup-form-header text-white p-3 text-center">Sign Up</h2>
          <div class="px-5 pt-3 pb-5 pt-md-5">
            <form @submit.prevent="saveUser">
              <div class="mb-3">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Your name"
                  v-model="name"
                  required
                />
              </div>
              <div class="mb-3">
                <input
                  type="email"
                  class="form-control"
                  placeholder="Your email"
                  v-model="email"
                  required
                />
              </div>
              <div class="mb-3">
                <select class="form-control" v-model="gender" required>
                  <option value="" disabled selected>Select Gender</option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                  <option value="non-binary">Non-Binary</option>
                  <option value="prefer-not-to-say">Prefer not to say</option>
                </select>
              </div>
              <div class="mb-3">
                <select class="form-control" v-model="age" required>
                  <option value="" disabled selected>Select Age Group</option>
                  <option value="-18">Under 18</option>
                  <option value="18-24">18 to 24</option>
                  <option value="25-34">25 to 34</option>
                  <option value="35-44">35 to 44</option>
                  <option value="45-54">45 to 54</option>
                  <option value="55-64">55 to 64</option>
                  <option value="65-">65 or over</option>
                </select>
              </div>
              <button type="submit" class="btn w-100">Register</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { openDB } from "idb";

export default {
  data() {
    return {
      name: "",
      email: "",
      gender: "",
      age: "",
      savedUser: null, // Stores user details if registered
      isRegistered: false, // Tracks whether a user is signed up
      firstName: null,
    };
  },
  async mounted() {
    await this.loadUser();
  },
  methods: {
    async loadUser() {
      try {
        const db = await openDB("AppDatabase");
        const user = await db.get("user", 1);

        if (user && user.name) {
          // Take the first word only
          let firstName = user.name.split(" ")[0];
          this.firstName = firstName;
        }

        if (user) {
          this.savedUser = user;
          this.isRegistered = true;
        }
      } catch (error) {
        console.error("Error loading user:", error);
      }
    },
    validateEmail(email) {
      // Simple regex for email validation
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email);
    },
    async saveUser() {
      // Check for a valid email before saving
      if (!this.validateEmail(this.email)) {
        alert("Please enter a valid email address.");
        return;
      }

      try {
        const db = await openDB("AppDatabase");
        await db.put("user", {
          id: 1,
          name: this.name,
          email: this.email,
          gender: this.gender,
          age: this.age,
        });

        alert("User details saved successfully!");

        // Reload user details after saving
        await this.loadUser();
      } catch (error) {
        console.error("Error saving user:", error);
      }
    },
  },
};
</script>

<style scoped>
.floating-badge {
  position: relative;
  float: right;
  top: -90px;

  width: 120px;
  height: auto;
  z-index: 10;
}

.signup-header {
  font-size: clamp(4.7916rem, 9.5832vw, 7.4868rem);
  margin-bottom: 0px;
  font-family: "Branding SF", sans-serif;
  font-weight: bold;
  color: var(--white-color);
}

.signup-text {
  font-size: clamp(1.35rem, 3.6vw, 2.025rem);
  font-family: "Myriad Pro", sans-serif;
  font-weight: 300;
  color: var(--white-color);
  line-height: 1.2em;
  margin-top: 40px;
}

.registerSubHeading {
  font-weight: bold;
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .floating-badge {
    position: absolute;
    top: -27px;
    right: 0px;

    width: 110px;
  }
  .full-width-image-section.footer {
    margin-top: 0px;
    background-color: #8cc73d;
    margin-bottom: 0px;
    padding-top: 35px !important;
  }
}
</style>
